import "./index.sass";
import { HeaderUnauth } from "@components/layout/Header/HeaderUnauth";
import { Footer } from "@components/layout/Footer";
import { useTranslation } from "@helpers/translate";

import BG from "@assets/images/404/bg.png";

export const NotFound = () => {
  const { __ } = useTranslation();

  return (
    <div className={`base-wrap`}>
      <div className="base-wrap__header">
        <HeaderUnauth />
      </div>

      <div className="base-wrap__content">
        <div className="notFound">
          <div className="notFound__wrap">
            <h1 className="notFound__title">404</h1>
            <img className="notFound__img" src={BG} />
            <p className="notFound__text">{__("common.page_not_found")}</p>
          </div>
        </div>
      </div>

      <div className="base-wrap__footer">{<Footer />}</div>
    </div>
  );
};
